import React from "react";

import "./assets/sass/style.scss";
import "./assets/sass/modern-portfolio.scss";

import Router from "./router/Router";
import Layout from "./layout/Layout";

function App() {
    return (
        <Layout className="modern-site">
            <Router/>
        </Layout>
    );
}

export default App;
